<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<Button type="primary" @click="add" >货道信息</Button>
			<Button type="primary" @click="update" v-show="macDetails.macDetailsName=='LRZ' && !aisleShow">修改</Button>
			<Button type="primary" @click="wancheng" v-show="macDetails.macDetailsName=='LRZ' && !aisleShow">录入完成</Button>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				 
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				macDetails:{},
				aisleShow:true,
				total:0,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '编号',
						key: 'number'
					},
					{
						title: '最大商品数',
						key: 'maxNumber'
					},
					{
						title: '备注',
						key: 'remark'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
				],
				modal2: false,
				modal_loading: false,
				loading:false,
				query:{
					page:0,
					size:10,
					macId:''
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			
			
			add() {//新增
				this.$router.push({
					name: 'jm/mac/aisle/add',
					query:{
						id:this.query.macId
					}
				})
			},
			update() {//新增
				this.$router.push({
					name: 'jm/mac/aisle/update',
					query:{
						id:this.query.macId
					}
				})
			},
			updatePage(page){//页码改变的回调，返回改变后的页码
				this.query.page=page-1
				this.reqPage()
			},
			updateSize(size){//切换每页条数时的回调，返回切换后的每页条数
				this.query.size=size
				this.reqPage()
			},
			reqPage(){
				this.loading=true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/aisle/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macAisles.totalElements
						_this.data6 = data.macAisles.content
						
						_this.loading = false
						if(_this.data6.length>0){
							_this.aisleShow=false
						}
						_this.loading=false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			get(){
				this.loading=true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/details/get',
				    data: {
						id:_this.query.macId
					},
					_this: _this,
					success: function(data) {
						_this.macDetails=data.macDetails
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			wancheng(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				   url: http.url + '/fac/mac/details/updateState',
				   data: {
				   	id: _this.query.macId,
				   	macDetailsState: "WC"
				   },
					_this: _this,
					success: function(data) {
						
						_this.$Message.success('修改成功!');
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
			
		},
	    components: {
	    	page
	    },
		created() {
			let t=this
			t.query.macId=t.$route.query.id
			t.reqPage()
			t.get()
		}
		
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/aisle/list.vue